export const SET_WIDGET_TITLE = 'setWidgetTitle';
export const GET_BUYERS = 'getBuyers';
export const GET_BUYER = 'getBuyer';
export const DELETE_BUYER = 'deleteBuyer';
export const RESET_BUYER_CALL_COUNTER = 'resetBuyerCallCounter';
export const SET_USER_VISIBLE_COLUMNS = 'setUserVisibleColumns';
export const GET_BUYER_REFERENCES = 'getBuyerReferences';
export const TOGGLE_BUYER_PERMISSION = 'toggleBuyerPermissionAction';
export const UPDATE_BUYER = 'updateBuyer';
export const CREATE_BUYER = 'createBuyer';
export const SAVE_BUYER = 'saveBuyer';
export const HANDLE_LINK_RPC = 'handleLinkRpc';
export const SET_INVITES_FOR_BUYER = 'SET_INVITES_FOR_BUYER';
export const SET_SHOW_NEW_BUYER_INVITES = 'SET_SHOW_NEW_BUYER_INVITES';
